import minBy from 'lodash/minBy';

import { numberToDollarString } from 'helpers/money';

export const calculatePricePerServingDetails = (
  mealPriceDetails,
  weeklyMeals,
  voucher = {},
  weeklyMealsMultiplier = 1
) => {
  const mealPriceDetail = mealPriceDetails.find(
    detail => detail.mealCount === weeklyMeals * weeklyMealsMultiplier
  );
  if (mealPriceDetail) {
    return { ...mealPriceDetail, hasPromo: mealPriceDetail.promoMealPriceCents !== null };
  } else {
    const minPriceTier = minBy(mealPriceDetails, 'mealPriceCents');
    const hasPromo = minPriceTier.promoMealPriceCents !== null;
    const subtotal = minPriceTier.mealPriceCents * (weeklyMeals * weeklyMealsMultiplier);
    let promoMealPriceFormatted = minPriceTier.mealPriceCents;
    if (voucher && voucher.discounts.length) {
      const firstDiscount = voucher.discounts.find(discount => discount.orderNumber === 1);
      let promoMealPriceCents;
      if (firstDiscount.percent) {
        const discountCents =
          subtotal < firstDiscount.maxAmountCents
            ? minPriceTier.mealPriceCents *
              (weeklyMeals * weeklyMealsMultiplier) *
              (firstDiscount.percent / 100)
            : firstDiscount.maxAmountCents;

        promoMealPriceCents = (subtotal - discountCents) / (weeklyMeals * weeklyMealsMultiplier);
      } else {
        promoMealPriceCents =
          (subtotal - firstDiscount.amountCents) / (weeklyMeals * weeklyMealsMultiplier);
      }
      promoMealPriceFormatted = numberToDollarString(promoMealPriceCents / 100);
    }
    return { ...minPriceTier, hasPromo, promoMealPriceFormatted };
  }
};

calculatePricePerServingDetails.propTypes = {
  mealPriceDetails: PropTypes.arrayOf(
    PropTypes.shape({
      mealCount: PropTypes.number.isRequired,
      mealPriceCents: PropTypes.number.isRequired,
      promoMealPriceCents: PropTypes.number,
    })
  ).isRequired,
  weeklyMeals: PropTypes.number.isRequired,
  voucher: PropTypes.shape({
    discounts: PropTypes.arrayOf(
      PropTypes.shape({
        orderNumber: PropTypes.number.isRequired,
        percent: PropTypes.number,
        amountCents: PropTypes.number,
        maxAmountCents: PropTypes.number,
      })
    ),
  }),
  weeklyMealsMultiplier: PropTypes.number,
};
